import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useTheme } from "../../../context/ThemeContext";
import Sidebar from "./components/Sidebar";
import Users from "./components/Users";
import Feedback from "./components/Feedback";
import Pricing from "./components/Pricing";
import ActivityLogs from "./components/ActivityLogs";

const AdminPanel = () => {
  const { isDarkTheme } = useTheme();

  return (
    <div className={`flex h-screen overflow-hidden ${isDarkTheme ? 'bg-dark-background text-white' : 'bg-[#fffcfc] text-black'}`}>
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <div className={`p-6 md:p-8 min-h-screen ${isDarkTheme ? 'bg-dark-background' : 'bg-gray-50'}`}>
          <Routes>
          <Route index element={<Users />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="activity-logs" element={<ActivityLogs />} />
            <Route path="statistics" element={<Pricing />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;